import { cx, type PidBaseProps } from './shared'

export interface SensorProps extends PidBaseProps {
  /** Free-form instrument type; first letter is drawn in the bubble. */
  type: string
  tag?: string
}

export function Sensor({ type, tag, className, style, title }: SensorProps) {
  const letter = (type.trim().charAt(0) || '?').toUpperCase()

  return (
    <div className={cx('pid-sensor', className)} style={style} title={title ?? tag ?? type}>
      <svg width={44} height={44} viewBox="0 0 44 44" aria-hidden>
        <circle className="pid-fill pid-stroke" cx={22} cy={22} r={18} strokeWidth={1.5} />
        <text
          className="pid-sensor-letter"
          x={22}
          y={26}
          textAnchor="middle"
          fontSize={14}
          fontWeight={600}
        >
          {letter}
        </text>
      </svg>
      {tag ? <div className="pid-tag">{tag}</div> : null}
    </div>
  )
}
